import React, { useEffect } from 'react';
import {
  CollectionsInsightRenderRegister,
  MultiEditCallbacks,
  MultiEditRegister,
  Proposition,
} from '@ecosystem/newron-client-collections';
import { InsightElement, getInsightInfo, getConfigItemCallbacks, multiEditCallbacks } from '@ecosystem/newron-core';

import { fetchCollectionsRegistry } from '../lib/bff.client';
import { InsightData } from '@ecosystem/newron-core/content/collection/types';
import { ConfigItemCallbacks } from '@ecosystem/newron-client-collections/build/shared/types';

export const CollectionProvider = ({ children }) => {
  useEffect(() => {
    loadCollectionsRegister();
  }, []);
  return <>{children}</>;
};

const loadCollectionsRegister = async () => {
  MultiEditRegister.getInstance().register(Proposition.Market, multiEditCallbacks as unknown as MultiEditCallbacks);
  MultiEditRegister.getInstance().register(
    Proposition.DistributionPanel,
    multiEditCallbacks as unknown as MultiEditCallbacks
  );

  const collectionsRegister = await fetchCollectionsRegistry();
  collectionsRegister.forEach(collection => {
    const instance = CollectionsInsightRenderRegister.getInstance();
    instance.register<InsightData>(
      { proposition: Proposition.Market, type: collection.collectionKey },
      {
        InsightRenderer: InsightElement,
        getInsightInfo: insight => getInsightInfo(insight, collection),
        configItemCallbacks: getConfigItemCallbacks() as ConfigItemCallbacks<InsightData, object>,
      }
    );

    instance.register<InsightData>(
      { proposition: Proposition.DistributionPanel, type: collection.collectionKey },
      {
        InsightRenderer: InsightElement,
        getInsightInfo: insight => getInsightInfo(insight, collection),
        configItemCallbacks: getConfigItemCallbacks() as ConfigItemCallbacks<InsightData, object>,
      }
    );
  });
};
